import type { ElementType, HTMLAttributes } from 'react';

import { transformRichtextInput } from '@tmh-website/services/text.service';
import StyledTypo, { TypographyProps } from '@tmh-website/styles/typo';

export interface RichtextProps extends HTMLAttributes<HTMLElement> {
  id?: any;
  input: string;
  disableLinks?: boolean;
  blurLinks?: boolean;
  injectRequiredIndicator?: boolean;
  typographyProps?: TypographyProps & { as?: ElementType };
}

const Richtext = ({
  input,
  disableLinks = false,
  blurLinks = false,
  injectRequiredIndicator = false,
  typographyProps,
  ...props
}: RichtextProps) => {
  if (!input) {
    return null;
  }

  const transformed = transformRichtextInput(input, {
    disableLinks,
    blurLinks,
    injectRequiredIndicator,
  });

  if (typographyProps) {
    return (
      <StyledTypo.Typography
        dangerouslySetInnerHTML={{ __html: transformed }}
        {...props}
        {...typographyProps}
        as={typographyProps.as ?? 'div'}
      />
    );
  } else {
    return <div style={{ overflowX: 'auto' }} dangerouslySetInnerHTML={{ __html: transformed }} {...props}></div>;
  }
};

export default Richtext;
